package org.moxultimate.topwithmox.dashboard

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import org.moxultimate.topwithmox.components.footer.Footer
import org.moxultimate.topwithmox.core.state.APIState
import org.moxultimate.topwithmox.di.koinViewModel
import org.moxultimate.topwithmox.theme.WhiteBG

/**
 * DashboardPage
 * Root composable for the dashboard. Fetches the latest 3 items per category via
 * [DashboardViewModel] and passes live data down to each content section.
 * Each section falls back to static placeholder cards when data is still loading or unavailable.
 */
@Composable
fun DashboardPage() {
    val viewModel: DashboardViewModel = koinViewModel()
    val latestState by viewModel.latestState.collectAsState()
    val latestData = (latestState as? APIState.Success)?.data

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(WhiteBG)
    ) {
        FirstSection()
        WallpaperSection()
        GameAppSection(apps = latestData?.apps)
        ShowAnimeSection(shows = latestData?.shows)
        TechSection(techs = latestData?.technology)
        ProductSection(products = latestData?.products)
        AboutSection()
        Footer()
    }
}
